import { apiHost } from '@libs/providers/api-host.provider';
const url = `${apiHost()}/web/application`;

export async function sendApplication(
  name: string,
  email: string,
  message: string,
  phone: string,
  links: string[],
  specialityIds: string[],
  files: any,
  vacancyId: string,
) {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('email', email);
  formData.set('message', message);
  formData.set('phone', phone);
  formData.set('links', JSON.stringify(links));
  formData.set('specialityIds', JSON.stringify(specialityIds));
  formData.set('vacancyId', vacancyId);
  files.forEach((file: any) => formData.append('files[]', file));
  return fetch(url, {
    method: 'POST',
    body: formData,
  }).then((res) => res.json());
}
